export const disableForWorkspaceRole = (currentRole, allowedRoles = []) =>
  !(!allowedRoles.length || allowedRoles.includes(currentRole));
